<a mat-list-item (click)="toggle()" style="width: fit-content;">
    <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}"
        class="submenu">
        <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Tabelas de Referência">
            <mat-icon>table_chart</mat-icon>
            <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Tabelas de Referência</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start stretch">
            <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
        </div>
    </div>
</a>

<mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

    <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">


    </div>
</mat-nav-list>